
import { useNavigate, useLocation } from 'react-router-dom'
import { AppLayout, type SidebarMenuItem, type SidebarBranding } from '@meiuca/ui-components'
import { Search, Calendar } from 'lucide-react'
import { UserLocationSelector } from './UserLocationSelector'
import { useAuth } from '@/contexts/AuthContext'

interface MeiucaAppLayoutProps {
  children: React.ReactNode
}

const branding: SidebarBranding = {
  logoText: 'M',
  appName: 'Meiuca',
  appSubtitle: 'App'
}

const menuItems: SidebarMenuItem[] = [
  {
    id: 'search',
    label: 'Pesquisar Jogos',
    icon: Search,
    path: '/'
  },
  {
    id: 'games',
    label: 'Meus Jogos',
    icon: Calendar,
    path: '/app/games'
  }
]

export function MeiucaAppLayout({ children }: MeiucaAppLayoutProps) {
  const navigate = useNavigate()
  const location = useLocation()
  const { logout, isAuthenticated, isLoading } = useAuth()

  const handleNavigation = (path: string) => {
    navigate(path)
  }

  const handleLogin = () => {
    navigate('/login')
  }

  const handleLogout = async () => {
    await logout()
    navigate('/')
  }

  // Filter menu items based on authentication status
  const getVisibleMenuItems = () => {
    if (!isAuthenticated) {
      // Only show search when not authenticated
      return menuItems.filter(item => item.id === 'search')
    }
    // Show all items when authenticated
    return menuItems
  }

  const topBarContent = (
    <>
      {/* Desktop: Location selector */}
      <div className="hidden md:flex items-center space-x-4">
        <UserLocationSelector 
          compact 
          onEditLocation={() => {
            console.log('🧭 Desktop location edit clicked, navigating to settings')
            navigate('/app/settings/location')
          }} 
        />
      </div>
      
      {/* Mobile: Location selector */}
      <div className="md:hidden">
        <UserLocationSelector 
          compact 
          showEditButton={false}
          onEditLocation={() => {
            console.log('🧭 Mobile location edit clicked, navigating to settings')
            navigate('/app/settings/location')
          }} 
        />
      </div>
    </>
  )

  console.log('🏗️ MeiucaAppLayout render:', { 
    currentPath: location.pathname,
    isAuthenticated,
    isLoading,
    topBarContentExists: !!topBarContent
  })

  return (
    <AppLayout
      branding={branding}
      menuItems={getVisibleMenuItems()}
      currentPath={location.pathname}
      onNavigate={handleNavigation}
      isAuthenticated={isAuthenticated}
      onLogin={handleLogin}
      onLogout={handleLogout}
      isLoading={isLoading}
      topBarContent={topBarContent}
    >
      {children}
    </AppLayout>
  )
}